const shouldForwardPropEmotion = (clearAttrs: string[]) => {
  return {
    shouldForwardProp: (prop: string) => !clearAttrs.includes(prop),
  };
};

export default shouldForwardPropEmotion;
